module.exports = __webpack_public_path__ + "img/3-5.6c942e08.svg";